import React from "react";
import { Link } from "react-router-dom";
import { Mixpanel } from "../../helpers/mixpanel";
import darkarrow from "../../assets/dark-arrow.svg";

function HowItWorks() {
  const steps = [
    {
      number: "1",
      title: "Enter Your Address",
      description: "Type your business address - we check availability instantly",
      time: "10 sec",
      icon: "📍",
    },
    {
      number: "2",
      title: "Choose Your Speed",
      description: "See available options from multiple carriers",
      time: "20 sec",
      icon: "⚡",
    },
    {
      number: "3",
      title: "Get Your Quote",
      description: "Real pricing delivered to your inbox immediately",
      time: "30 sec",
      icon: "📧",
    },
  ];

  return (
    <div className="bg-f2 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl xl:text-4xl font-bold text-center text-dark mb-3">
          How It Works
        </h2>
        <p className="text-center text-lightgray mb-10 md:mb-16 text-base md:text-lg">
          Skip the sales calls. Get real pricing in under a minute.
        </p>

        <div className="grid md:grid-cols-3 gap-8 md:gap-6">
          {steps.map((step) => (
            <div key={step.number} className="text-center">
              <div className="w-16 h-16 bg-blue text-white rounded-full flex items-center justify-center text-2xl mx-auto mb-4">
                {step.icon}
              </div>
              <div className="text-orange font-bold text-lg mb-2">
                {step.time}
              </div>
              <h3 className="text-xl font-bold text-dark mb-2">{step.title}</h3>
              <p className="text-lightgray text-sm">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-xl shadow-lg p-6 md:p-8">
          <h3 className="text-xl md:text-2xl font-bold text-center text-dark mb-8">
            FiberFed Finder vs Traditional Sales Process
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="text-center p-6 bg-green-50 rounded-xl border-2 border-green-200">
              <div className="text-4xl mb-3">⚡</div>
              <div className="font-bold text-green-700 text-lg">
                FiberFed Finder
              </div>
              <div className="text-4xl md:text-5xl font-bold text-green-600 my-3">
                60 seconds
              </div>
              <ul className="text-sm text-green-700 space-y-1">
                <li>✓ Instant pricing</li>
                <li>✓ No phone calls</li>
                <li>✓ Compare carriers</li>
                <li>✓ $5 gift card bonus</li>
              </ul>
            </div>

            <div className="text-center p-6 bg-red-50 rounded-xl border-2 border-red-200">
              <div className="text-4xl mb-3">📞</div>
              <div className="font-bold text-red-700 text-lg">
                Traditional Carrier
              </div>
              <div className="text-4xl md:text-5xl font-bold text-red-600 my-3">
                3-5 days
              </div>
              <ul className="text-sm text-red-700 space-y-1">
                <li>✗ Multiple sales calls</li>
                <li>✗ Waiting for callbacks</li>
                <li>✗ Single carrier options</li>
                <li>✗ Pressure tactics</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex justify-center">
          <Link to="/app/pick-mechanism">
            <button
              className="cta cta-hover uppercase bg-orange border-orange text-dark text-base px-8 py-4 font-bold"
              onClick={() => Mixpanel.track("CLICKED GET QUOTE - HOW IT WORKS")}
            >
              Get My Quote in 60 Seconds <img alt="arrow" src={darkarrow} />
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
